import Animated, {
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { useHeightContainer } from './styles'

interface Props {
  children: React.ReactNode
  animation: SharedValue<number>
  index: number
  total: number
}

const cnOuter =
  'absolute inset-0 flex w-full items-center justify-center gap-8 flex-row'

export default function RecommendationRow({
  children,
  animation,
  index,
  total,
}: Props) {
  const { height, top, move } = useHeightContainer()

  const style = useAnimatedStyle(() => {
    const range = [index - 1, index, index + 1]
    return {
      transform: [
        {
          translateY: interpolate(animation.value, range, [move, 0, move]),
        },
      ],
      pointerEvents: animation.value === index ? 'auto' : 'none',
      opacity: interpolate(animation.value, range, [0, 1, 0]),
    }
  })

  return (
    <Animated.View
      style={[style, { minHeight: height, height, top }]}
      className={cn(cnOuter, total >= 3 && 'flex-wrap')}
    >
      {children}
    </Animated.View>
  )
}
